import '@qsrsoft/myq-core/styles';
import 'vuetify/dist/vuetify.css';

import App from './App.vue';
import { router, vuetify, initVueWithAuth } from '@qsrsoft/myq-core';
import { getRoutes } from '@/views/routes';
import Highcharts from 'highcharts';
import Stock from 'highcharts/modules/stock';
import HighchartsVue from 'highcharts-vue';
import { i18n } from '@qsrsoft/myq-core';
import domainTranslations, { SUPPORTED_LOCALES } from '@/i18n';

async function loadApp() {
  // trickery to get refreshing to work with multi enterprise routes
  let routes;
  const userString = localStorage.getItem('user');
  if (userString) {
    const user = JSON.parse(userString);
    const enterprise = user?.user?.organization?.enterpriseClient;
    const countryCode = user?.user?.organization?.countryCode;
    routes = getRoutes(enterprise, countryCode);
  }
  Stock(Highcharts);

  // Merge domain translations into the global vue-i18n instance
  // so Options API components using $t() can access them
  for (const locale of SUPPORTED_LOCALES) {
    i18n.global.mergeLocaleMessage(locale, domainTranslations[locale] || {});
  }

  const app = await initVueWithAuth({
    app: App,
    routes,
    vuetify,
    router,
  });
  app.use(HighchartsVue);
  app.mount('#app');
}

loadApp();
